module.exports = __webpack_public_path__ + "images/sgp/SGPHero/mini-self-storage-hero.webp";